// React
import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Col, Container, Row, CardHeader } from 'reactstrap';
import DataTableExtensions from 'react-data-table-component-extensions';

// Containers Injections
import {
  DropdownDatatable,
  ModalHistoryStatus,
} from '../../../../containers/componentsInjection';

// Helpers & Redux
import {
  CreateHistoryStatus,
  DeleteHistoryStatus,
  GetHistoryStatus as historyDispatch,
} from '../../../../../../store/historyStatus/action';
import { useLoading } from '../../../../../../hook/useLoading';

const HistoryStatus = ({ id }) => {
  const [modal_animationLeft, setmodal_animationLeft] = useState(false);

  const dispatch = useDispatch();
  const { loadingWithTime } = useLoading();

  const { historyStatus, success } = useSelector((state) => ({
    error: state.HistoryStatus.error,
    historyStatus: state.HistoryStatus.historyStatus,
    success: state.HistoryStatus.success,
  }));

  function tog_animationLeft() {
    setmodal_animationLeft(!modal_animationLeft);
  }

  const handleSubmit = (e) => {
    e.preventDefault();

    let form = {
      proposal_id: id,
      subject: e.target.subjectInput.value,
      notes: e.target.detailsInput.value,
    };

    // to prevent submit with empty inputs
    if (e.target.subjectInput.value) {
      loadingWithTime(1000);
      dispatch(CreateHistoryStatus(form));
      tog_animationLeft();
    }
  };

  const handleDelete = (id) => {
    dispatch(DeleteHistoryStatus(id));
  };

  const columns = [
    {
      name: <span className="font-weight-bold fs-13">Assunto</span>,
      sortable: true,
      selector: (cell) => {
        return (
          <ul
            className="list-inline hstack gap-2 mb-0 "
            style={{
              width: '100%',
              display: 'flex',
              alignSelf: 'center',
            }}
          >
            <li className="list-inline-item">{cell.subject}</li>
          </ul>
        );
      },
    },
    {
      name: <span className="font-weight-bold fs-13">Notas</span>,
      selector: (row) => row.notes,
      sortable: true,
      width: '35%',
    },
    {
      name: <span className="font-weight-bold fs-13">Data de alteração</span>,
      selector: (row) => row.event_date,
      sortable: true,
      width: '10%',
    },
    {
      name: <span className="font-weight-bold fs-13">Status</span>,
      sortable: true,
      width: '10%',
      selector: (cell) => {
        return (
          <span
            className={`badge badge-border badge-soft-${cell.status_color}`}
          >
            {cell.status}
          </span>
        );
      },
    },
    {
      width: '10%',
      name: <span className="font-weight-bold fs-13">Alterado por</span>,
      selector: (row) => row.user_name,
      sortable: true,
    },
  ];

  useEffect(() => {
    if (id) {
      dispatch(historyDispatch(id));
    }
  }, [dispatch, id, success]);

  return (
    <React.Fragment>
      <Container fluid>
        <Row className="justify-content-center">
          <Col xxl={12}>
            <CardHeader className="border-bottom-dashed">
              <Row className="g-4 align-items-center">
                <div className="col-sm">
                  <div>
                    <h5 className="card-title mb-0">Histórico de Eventos</h5>
                  </div>
                </div>
                <div className="col-sm-auto">
                  <div>
                    <button
                      type="button"
                      className="btn btn-success add-btn"
                      id="create-btn"
                      onClick={() => {
                        tog_animationLeft();
                      }}
                    >
                      <i className="ri-add-line align-bottom me-1"></i>
                      Novo Evento
                    </button>{' '}
                  </div>
                </div>
              </Row>
            </CardHeader>

            <DataTableExtensions
              print={false}
              export={false}
              filterPlaceholder="Pesquisar..."
              columns={columns}
              data={historyStatus ? historyStatus : []}
            >
              <DropdownDatatable
                canSearch={false}
                pagination
                persistTableHead
                perPage={10}
                handleDelete={(cellProps) => handleDelete(cellProps)}
              />
            </DataTableExtensions>

            <ModalHistoryStatus
              toggle={tog_animationLeft}
              isOpen={modal_animationLeft}
              handleSubmit={handleSubmit}
            />
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  );
};

export default HistoryStatus;
